/**
 * Returns a custom data attribute to empower element targeting within our QA automation scripts.
 * @param {string} key An identifier to target specific element(s).
 */
export function getQaKey(key) {
	return { 'data-qa': key };
}
